import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { catchError, switchMap, exhaustMap } from "rxjs/operators";
import { of } from "rxjs";

import { ProfileService } from "@skills-app/services/profile.service";
import * as NotificationActions from "../../notifications/actions/notification.actions";

import {
  ConsultantSkillApiActions,
  MyProfilePageActions,
} from "@skills-app/consultant-skill/actions";
import * as ViewProfilePageActions from "@skills-app/consultant-skill/actions/view-profile-page.actions";

@Injectable()
export class ViewProfileEffects {
  constructor(
    private readonly actions$: Actions,
    private readonly profileService: ProfileService,
  ) {}

  loadSelectedProfile$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ViewProfilePageActions.loadPage),
      exhaustMap(({ azureId }) =>
        this.profileService.getProfileByAzureId(azureId).pipe(
          switchMap((profile) => {
            if (!profile) {
              return of(
                ViewProfilePageActions.loadPageError(),
                NotificationActions.snackbarOpen({
                  message: "Error: Unable to load profile.",
                }),
              );
            }

            // ✅ Rich profile parity:
            // - Populate profile DTO
            // - Also load rated skills + certifications (these are not guaranteed to be embedded)
            return of(
              ConsultantSkillApiActions.populateSelectedUserProfile({
                profile,
              }),
              ConsultantSkillApiActions.requestSelectedUserSkills({ azureId }),
              MyProfilePageActions.requestSelectedUserCertifications({
                azureId,
              }),
              MyProfilePageActions.requestUserProfileStatus({ azureId }),
            );
          }),
          catchError(() =>
            of(
              ViewProfilePageActions.loadPageError(),
              NotificationActions.snackbarOpen({
                message: "Error: Unable to load profile.",
              }),
            ),
          ),
        ),
      ),
    ),
  );
}
